import { render, staticRenderFns } from "./PropPreview.vue?vue&type=template&id=67fdf184&"
import script from "./PropPreview.vue?vue&type=script&lang=js&"
export * from "./PropPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports